<template>
  <div class="app flex-row align-items-center" id="registerSafePlaceUser-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="12 text-center mt-3">
          <Header></Header>
        </b-col>
        <b-col class="mt-5" md="8" sm="8">
            <el-form
                :model="mData.dataForm"
                :rules="mData.validForm"
                ref="myForm"
                label-width="100%"
                label-position="top"
                @submit.native.prevent
                class="mt-1"
            >
                <div class="card" style="border-radius: 11px;">
                    <div class="card-header">
                        <p style="font-weight: bold">
                            DECLARATION
                        </p>
                    </div>
                    <div class="card-body">
                        <div class="health-declaration">
                            <el-collapse v-model="mData.dataDefault.activeName">
                                <el-collapse-item title="Health declaration" name="1">
                                    <b-row>
                                        <b-col md="12">
                                            <el-form-item
                                                label="In the past 14 days, which country (countries) / territory (territories) have you been to? "
                                                prop="y_te.danh_sach_quoc_gia_da_den"
                                            >
                                                <el-select
                                                    v-model="mData.dataForm.y_te.danh_sach_quoc_gia_da_den"
                                                    placeholder="Choose one or more"
                                                    multiple
                                                    filterable
                                                    auto-complete="off"
                                                    @input="forceUpdateUI"
                                                >
                                                    <el-option
                                                        v-for="item in mData.dataDefault.listQuocGia"
                                                        :key="item.id"
                                                        :value="item.id"
                                                        :label="
                                                        item.ten_quoc_gia && item.ten_quoc_gia.en
                                                            ? item.ten_quoc_gia.en
                                                            : ''
                                                        "
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </b-col>
                                        <b-col md="12">
                                            <el-form-item
                                                label="In the past 14 days, did you have any of these following symptoms?"
                                                prop="y_te.danh_sach_dau_hieu"
                                            >
                                                <el-select
                                                    v-model="mData.dataForm.y_te.danh_sach_dau_hieu"
                                                    placeholder="Keep blank if you did not have any symptom"
                                                    multiple
                                                    filterable
                                                    auto-complete="off"
                                                    @input="forceUpdateUI"
                                                >
                                                    <el-option
                                                        v-for="item in mData.dataDefault.listDauHieu"
                                                        :key="item.value"
                                                        :value="item.value"
                                                        :label="item.name"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </b-col>
                                        <b-col md="12">
                                            <el-form-item
                                                label="In the past 14 days, have you been exposed to"
                                                prop="y_te.danh_sach_tiep_xuc"
                                            >
                                                <el-select
                                                    v-model="mData.dataForm.y_te.danh_sach_tiep_xuc"
                                                    placeholder="Keep blank if you have not been exposed to"
                                                    multiple
                                                    filterable
                                                    auto-complete="off"
                                                    @input="forceUpdateUI"
                                                >
                                                    <el-option
                                                        v-for="item in mData.dataDefault.listKBYTTiepXuc"
                                                        :key="item.id"
                                                        :value="item.id"
                                                        :label="item.ten && item.ten.en ? item.ten.en : ''"
                                                        class="custom-select-break-line"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </b-col>
                                        <b-col md="12">
                                            <el-form-item
                                                label="Which of the following diseases do you currently have?"
                                                prop="y_te.danh_sach_benh"
                                            >
                                                <el-select
                                                    v-model="mData.dataForm.y_te.danh_sach_benh"
                                                    placeholder="Keep blank if you did not have any disease"
                                                    multiple
                                                    filterable
                                                    auto-complete="off"
                                                    @input="forceUpdateUI"
                                                >
                                                    <el-option
                                                        v-for="item in mData.dataDefault.listKBYTBenh"
                                                        :key="item.id"
                                                        :value="item.id"
                                                        :label="item.ten && item.ten.en ? item.ten.en : ''"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </b-col>
                                        <b-col md="12">
                                            <el-form-item label="Body temperature (Use '.' for temperature, ex: 36.5)" prop="y_te.than_nhiet">
                                                <el-input
                                                    class="text-center"
                                                    v-model="mData.dataForm.y_te.than_nhiet"
                                                    auto-complete="off"
                                                    @input="forceUpdateUI"
                                                ></el-input>
                                            </el-form-item>
                                        </b-col>
                                    </b-row>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    
                        <div class="vaccine-certificate mt-3">
                            <el-collapse v-model="mData.dataDefault.activeName1">
                                <el-collapse-item title="Vaccine certificate" name="2">
                                    <b-row>
                                        <b-col md="12">
                                            <el-form-item label="Injection Certificate" prop="loai">
                                                <el-radio
                                                    class="mr-2"
                                                    v-model="mData.dataForm.loai"
                                                    :label="1"
                                                    @change="changeRadioValue(mData.dataForm.loai)"
                                                >Photo</el-radio>
                                                    <el-radio
                                                    class="mr-2"
                                                    v-model="mData.dataForm.loai"
                                                    :label="2"
                                                    @change="changeRadioValue(mData.dataForm.loai)"
                                                >QR code</el-radio>
                                            </el-form-item>
                                        </b-col>
                                        <b-col md="12" v-show="mData.dataForm.loai == 1">
                                            <el-form-item
                                                label="Photo certificate"
                                                prop="tiem_chung.anh_id"
                                            >
                                                <el-upload
                                                    action
                                                    :auto-upload="false"
                                                    drag
                                                    :limit="mData.fileUploadOption.Anh.limit"
                                                    :accept="mData.fileUploadOption.Anh.accept"
                                                    :on-change="fn_uploadChangeAnh"
                                                    :on-preview="fn_uploadPreviewAnh"
                                                    :on-remove="fn_uploadRemoveAnh"
                                                    :on-exceed="fn_uploadExceedAnh"
                                                    :file-list="mData.fileUploadOption.Anh.fileList"
                                                    :multiple="false"
                                                    :class="{ hide: mData.dataDefault.anh }"
                                                >
                                                    <div v-if="!mData.dataDefault.anh">
                                                        <i class="el-icon-upload"></i>
                                                        <div class="el-upload__text">
                                                            Drop photo here or <em>click to upload</em>
                                                        </div>
                                                    </div>
                                                </el-upload>
                                                <div
                                                    class="d-flex justify-content-center"
                                                    style="max-width: 350px"
                                                    v-if="mData.dataDefault.anh"
                                                >
                                                    <el-image :src="mData.dataDefault.anh" lazy></el-image>
                                                </div>
                                            </el-form-item>
                                        </b-col>
                                        <b-col md="12" v-show="mData.dataForm.loai == 2">
                                            <div class="d-flex jusity-content-center" v-if="mData.dataDefault.showCamera">
                                                <el-form-item label="QR code" prop="tiem_chung.qr" v-if="mData.dataForm.loai == 2">
                                                <div
                                                    class="mb-3"
                                                    style="width: 300px; height: 300px"
                                                    
                                                >
                                                    <QrcodeStream @decode="onDecode"/>
                                                    <!-- <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" v-if="mData.dataDefault.camera == 'off'">
                                                        <a style="font-size: 180px; cursor: pointer;" @click="openCamera()"><i class="fa fa-qrcode" aria-hidden="true"></i></a>
                                                    </div> -->
                                                </div>
                                                <!-- <el-input
                                                    v-model="mData.dataForm.tiem_chung.qr"
                                                    auto-complete="off"
                                                ></el-input> -->
                                                </el-form-item>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col xl="7" lg="12">
                                            <el-form-item label="Vaccine" :prop="mData.dataDefault.certificateByQR ? '' : 'tiem_chung.vaccine'">
                                                <el-select
                                                    v-model="mData.dataForm.tiem_chung.vaccine"
                                                    @change="fn_changeVaccine()"
                                                    placeholder="Select"
                                                    :disabled="mData.dataDefault.certificateByQR"
                                                    @input="forceUpdateUI"
                                                >
                                                    <el-option
                                                        v-for="item in mData.dataDefault.listVaccine"
                                                        :key="item.id"
                                                        :value="item.id"
                                                        :label="item.ten"
                                                        auto-complete="off"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </b-col>
                                        <b-col xl="5" lg="12" v-if="mData.dataDefault.certificateByQR">
                                            <el-form-item
                                                label="Date of expiry"
                                                :prop="mData.dataDefault.certificateByQR ? '' : 'tiem_chung.gia_tri_den'"
                                            >
                                                <el-date-picker
                                                    v-model="mData.dataForm.tiem_chung.gia_tri_den"
                                                    type="date"
                                                    :format="aElement.datepicker.formatDate"
                                                    :valueFormat="aElement.datepicker.valueFormat + '+07:00'"
                                                    auto-complete="off"
                                                    :disabled="mData.dataDefault.certificateByQR"
                                                    @input="forceUpdateUI"
                                                >
                                                </el-date-picker>
                                            </el-form-item>
                                        </b-col>
                                        <b-col xl="7" lg="12">
                                            <el-form-item
                                                label="Certificate number"
                                                :prop="mData.dataDefault.certificateByQR ? '' : 'tiem_chung.so_giay_chung_nhan'"
                                            >
                                                <el-input
                                                    v-model="mData.dataForm.tiem_chung.so_giay_chung_nhan"
                                                    auto-complete="off"
                                                    :disabled="mData.dataDefault.certificateByQR"
                                                    @input="forceUpdateUI"
                                                ></el-input>
                                            </el-form-item>
                                        </b-col>
                                        <b-col xl="5" lg="12">
                                            <el-form-item
                                                label="Injection country"
                                                :prop="mData.dataDefault.certificateByQR ? '' : 'tiem_chung.quoc_gia_id'"
                                            >
                                                <el-select
                                                    v-model="mData.dataForm.tiem_chung.quoc_gia_id"
                                                    placeholder="Choose"
                                                    filterable
                                                    auto-complete="off"
                                                    :disabled="mData.dataDefault.certificateByQR"
                                                    @change="test(mData.dataForm.tiem_chung.quoc_gia_id)"
                                                    @input="forceUpdateUI"
                                                >
                                                    <el-option
                                                        v-for="item in mData.dataDefault.listQuocGia"
                                                        :key="item.id"
                                                        :value="item.id"
                                                        :label="
                                                        item.ten_quoc_gia && item.ten_quoc_gia.en
                                                            ? item.ten_quoc_gia.en
                                                            : ''
                                                        "
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </b-col>
                                    </b-row>
                                    <b-row
                                        v-for="(luot_tiem, index) in mData.dataForm.tiem_chung.luot_tiem"
                                        :key="index"
                                    >
                                        <b-col xl="7" lg="12">
                                            <el-form-item
                                                :label="'Injection place (' + renderTimes(index) + ')'"
                                                :prop="mData.dataDefault.certificateByQR ? '' : 'tiem_chung.luot_tiem[' + index + '].dia_diem_tiem'"
                                            >
                                                <el-input
                                                    v-model="luot_tiem.dia_diem_tiem"
                                                    auto-complete="off"
                                                    :disabled="mData.dataDefault.certificateByQR"
                                                    @input="forceUpdateUI"
                                                ></el-input>
                                            </el-form-item>
                                        </b-col>
                                        <b-col xl="5" lg="12">
                                            <el-form-item
                                                :label="'Injection time (' + renderTimes(index) + ')'"
                                                :prop="mData.dataDefault.certificateByQR ? '' : 'tiem_chung.luot_tiem[' + index + '].thoi_gian_tiem'"
                                            >
                                                <el-date-picker
                                                    v-model="luot_tiem.thoi_gian_tiem"
                                                    type="date"
                                                    :format="aElement.datepicker.formatDate"
                                                    :valueFormat="aElement.datepicker.valueFormat + '+07:00'"
                                                    auto-complete="off"
                                                    :disabled="mData.dataDefault.certificateByQR"
                                                    @input="forceUpdateUI"
                                                >
                                                </el-date-picker>
                                            </el-form-item>
                                        </b-col>
                                    </b-row>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                        <div class="account mt-3 mb-4">
                            <el-collapse v-model="mData.dataDefault.activeName2">
                                <el-collapse-item title="Account" name="3">
                                    <el-form-item label prop="email" class="el-form-item--medium">
                                        <div class="email-notice mb-1">
                                            An mail will be sent to this email to confirm that your account was created. <em>Note: email may be in Junk / Spam folder</em>
                                        </div>
                                        <el-input
                                            prefix-icon="el-icon-user"
                                            placeholder="Email*"
                                            v-model.trim="mData.dataForm.email"
                                            autocomplete="new-password"
                                            clearable
                                        ></el-input>
                                    </el-form-item>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                        <el-form-item>
                            <div class="btn-group">
                                <el-button 
                                    class="btn-back"
                                    @click="fn_go()" 
                                    type="info" 
                                    plain
                                >BACK</el-button>
                                <el-button
                                    type="primary"
                                    class="btn-next"
                                    @click="fn_submitForm()"
                                    v-ladda
                                    native-type="submit"
                                    >Register</el-button
                                >
                            </div>
                        </el-form-item>
                    </div>
                    <div class="card-footer">
                    </div>
                </div>
            </el-form>
        </b-col>
        <b-col md="12" class="text-center mt-3">
          <Footer></Footer>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import MethodService from "../../service/MethodService";
import ExtensionService from "../../service/ExtensionService";
import ValidService from '../../service/ValidService';
import QuocGiaApi from "../../moduleApi/QuocGiaApi";
import KBYTTiepXucApi from "../../moduleApi/KBYTTiepXucApi";
import KBYTBenhApi from "../../moduleApi/KBYTBenhApi";
import VaccineApi from "../../moduleApi/VaccineApi";
import ForeignApi from "../../moduleApi/ForeignerApi";
import ForeignerQrApi from "../../moduleApi/ForeignerQrApi";
import AuthService from "../../service/AuthService";
import Header from "../../containers/HeaderRegister";
import Footer from "../../containers/FooterRegister";
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";

export default {
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
    Header,
    Footer
  },
  data() {
    var validateImage = (rule, value, callback) => {
      if (!value && this.mData.dataForm.loai == "1") {
        callback(new Error("Please upload a photo"));
      } else {
        callback();
      }
    };
    var validateQR = (rule, value, callback) => {
      if (!value && this.mData.dataForm.loai == "2") {
        callback(new Error("Please scan QR"));
      } else {
        callback();
      }
    };

    let validateTemperature = (rule, value, callback) => {
    //   if (!value)
    //   {
    //     callback(new Error("Please enter body temperature"));
    //   }
    //   else 
      if((value != undefined && value != "") && (isNaN(value))){
        callback(new Error("Invalid temperature"));
      }else if ((value != undefined &&value != "" ) && (value < 30 || value > 45)) {
        callback(new Error("Please enter body tempertature between 30 and 45 degree"));
      }
      else {
        callback();
      }
    };
    
    return {
        noMatchName: false,
        noMatchDOB: false,
        noMatchGender: false,
        noMatchPassportNo: false,
        aLang: LanguageService.lang,
        aElement: MethodService.element,
        mData: {
            dataDefault: {
                camera: 'auto',
                showCamera: true,
                certificateByQR: false,
                error: "",
                showDismissibleAlert: false,
                success: "",
                showDismissibleAlertSuccess: false,
                listQuocGia: [],
                listDauHieu: [
                    {
                        name: "Cough",
                        value: "ho",
                    },
                    {
                        name: "Fever",
                        value: "sot",
                    },
                    {
                        name: "Shortness of breath",
                        value: "kho_tho",
                    },
                    {
                        name: "Pneumonia",
                        value: "viem_phoi",
                    },
                    {
                        name: "Sore throat",
                        value: "dau_hong",
                    },
                    {
                        name: "Tiredness",
                        value: "met_moi",
                    },
                ],
                activeName: "1",
                activeName1: "2",
                activeName2: "3",
                dataPassport: {
                    anh_chan_dung_id: null,
                    ho_chieu: {
                        loai: "",
                        ma_so: "",
                        ho_ten: "",
                        quoc_tich_id: "",
                        ngay_sinh: null,
                        so_ho_chieu: "",
                        noi_sinh: "",
                        gioi_tinh: null,
                        cmnd: "",
                        ngay_cap: null,
                        hieu_luc_den: null,
                        noi_cap: "",
                    },
                },
                anhSelfie: "",
                anhPassport: "",
                listKBYTTiepXuc: [],
                listKBYTBenh: [],
                listVaccine: [],
                anh: "",
                data: null,
            },
            dataForm: {
                email: "",
                y_te: {
                    danh_sach_quoc_gia_da_den: "",
                    danh_sach_dau_hieu: "",
                    danh_sach_tiep_xuc: "",
                    danh_sach_benh: "",
                    than_nhiet: undefined,
                },
                tiem_chung: {
                    luot_tiem: [
                    {
                        thoi_gian_tiem: null,
                        dia_diem_tiem: "",
                    },
                    ],
                    vaccine: "",
                    gia_tri_den: null,
                    so_giay_chung_nhan: "",
                    anh_id: "",
                    qr: "",
                    link: "",
                },
                loai: "",
            },
            validForm: {
                email: [
                    {
                    required: true,
                    message: "Please enter your email",
                    trigger: "blur",
                    },
                    {
                    pattern: /^[a-zA-Z0-9.!$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/g,
                    message: "Email is invalid",
                    trigger: "blur",
                    }
                ],
                loai: [
                    {
                    required: true,
                    message: "Please choose a value",
                    trigger: "blur",
                    },
                    ValidService.checkSpaceString
                ],
                "y_te.danh_sach_quoc_gia_da_den": [
                    // {
                    //     required: true,
                    //     message: "Please choose a value",
                    //     trigger: "blur",
                    // },
                ],
                "y_te.danh_sach_dau_hieu": [],
                "y_te.danh_sach_tiep_xuc": [],
                "y_te.danh_sach_benh": [],
                "y_te.than_nhiet": [
                    {
                    validator: validateTemperature,
                    trigger: "blur",
                    },
                ],
                "tiem_chung.luot_tiem[0].thoi_gian_tiem": [
                    {
                    required: true,
                    message: "Please enter a value",
                    trigger: "blur",
                    },
                    {
                    validator: this.validateNgayHetHan,
                    trigger: "blur",
                    },
                ],
                "tiem_chung.luot_tiem[0].dia_diem_tiem": [
                    {
                    required: true,
                    message: "Please enter a value",
                    trigger: "blur",
                    },
                    ValidService.checkSpaceString
                ],
                "tiem_chung.quoc_gia_id":[
                    {
                    required: true,
                    message: "Please enter a value",
                    trigger: "blur",
                    },
                ],
                "tiem_chung.vaccine": [
                    {
                    required: true,
                    message: "Please enter a value",
                    trigger: "blur",
                    },
                ],
                "tiem_chung.gia_tri_den": [
                    {
                        validator: this.validateNgayHetHan1,
                        trigger: "blur",
                    },
                ],
                "tiem_chung.so_giay_chung_nhan": [
                    {
                    required: true,
                    message: "Please enter a value",
                    trigger: "blur",
                    },
                    ValidService.checkSpaceString
                ],
                "tiem_chung.anh_id": [
                    {
                    validator: validateImage,
                    trigger: "change",
                    },
                ],
                "tiem_chung.qr": [
                {
                validator: validateQR,
                trigger: "blur",
                },
            ],
            },
            fileUploadOption: {
                Anh: {
                    limit: 1,
                    accept: ".jpg, .png, .jpeg",
                    dialogImageUrl: "",
                    dialogVisible: false,
                    fileList: [],
                },
            },
        },
    };
  },
  methods: {
    fn_submitForm() {
        this.$refs["myForm"].validate(async (valid) => {
            if (valid) {
                let data = JSON.parse(
                    JSON.stringify(this.mData.dataDefault.dataPassport)
                );
                if(this.mData.dataForm.tiem_chung.so_giay_chung_nhan){
                    this.mData.dataForm.tiem_chung.so_giay_chung_nhan = this.mData.dataForm.tiem_chung.so_giay_chung_nhan.trim();
                }
                if(this.mData.dataForm.tiem_chung.luot_tiem.length > 0){
                    for(let i = 0 ; i < this.mData.dataForm.tiem_chung.luot_tiem.length ; i++ ){
                        if(this.mData.dataForm.tiem_chung.luot_tiem[i].dia_diem_tiem){
                            this.mData.dataForm.tiem_chung.luot_tiem[i].dia_diem_tiem = this.mData.dataForm.tiem_chung.luot_tiem[i].dia_diem_tiem.trim(); 
                        }
                    }
                }
                if(!this.mData.dataForm.y_te.than_nhiet){
                    this.mData.dataForm.y_te.than_nhiet = null;
                }
                let dataPassport = data.dataPassport;
                let dataDeclaration = {
                    khai_bao : {
                        loai : this.mData.dataForm.loai,
                        y_te : this.mData.dataForm.y_te,
                        tiem_chung : this.mData.dataForm.tiem_chung
                    }
                };
                dataPassport.email = this.mData.dataForm.email;
                let res;
                let dataQR;
                let mailData;
                console.log("this.mData.dataForm register",this.mData.dataForm);
                try {
                    res = await ForeignApi.registerForeigner(dataPassport);
                } catch (error) {
                    if (error.code === 3000) {
                        window.toastr.error(`Passport No. '${dataPassport.ho_chieu.so_ho_chieu}' is already registered`);  

                    }
                    else {
                        window.toastr.error("An error occurred, please try again!");
                    }
                    MethodService.stopLadda();
                    return;
                }
                try {
                    if (res.result && res.result.account && res.result.password) {
                        try {
                            await AuthService.login(res.result.account, res.result.password, true);
                            dataQR = await ForeignerQrApi.create({});
                            if(dataQR.result){
                                mailData = {
                                    id: dataQR.result,
                                    password: res.result.password
                                };
                                await ForeignApi.sendEmail(mailData);
                                dataDeclaration.id = dataQR.result;
                                let updateDeclaration = await ForeignerQrApi.update(dataDeclaration);
                                
                                if(updateDeclaration.result){
                                    await ForeignerQrApi.submitDeclaration(updateDeclaration.result,{});
                                }
                                this.$alert(
                                    "<p style='font-size:16px; font-weight:bold;'>Account information has been sent to the registered email address.</p>" + 
                                    "<p style='font-size:14px;'><i>Please check your email to receive the necessary information (pay attention to check your Spam folder).</i></p>",
                                     '',{
                                            dangerouslyUseHTMLString: true,
                                            confirmButtonText: "OK",
                                            showClose: false,
                                            showCancelButton: false,
                                            closeOnPressEscape: false,
                                            closeOnClickModal: false,
                                            closeOnHashChange: false,
                                        }
                                )
                                .then(() => {
                                    AuthService.logout(false)
                                    .then(res => {
                                        console.log(res);
                                        this.$router.push({ name: "Auth-ForeignLogin" });
                                    })
                                    .catch(error => {
                                        console.log(error);
                                        this.$message({
                                            showClose: true,
                                            message: "An error occurred, please try again!",
                                            type: "error"
                                        });
                                    });
                                    sessionStorage.removeItem("foreignRegister");
                                })
                            }
                        } catch (error) {
                            window.toastr.error("An error occurred, please try again!");
                        } 
                    }
                } catch (error) {
                    MethodService.stopLadda();
                    this.$router.push({ name: "Auth-ForeignLogin" });
                    return;
                }
            } else {
                MethodService.stopLadda();
                return false;
            }
        });
    },
    async getNationalityList() {
        const nationality = await QuocGiaApi.list();
        this.mData.dataDefault.listQuocGia = nationality.result;
    },
    async getInitData(){
        let resTX = await KBYTTiepXucApi.list();
        this.mData.dataDefault.listKBYTTiepXuc = resTX.result;
        let resBenh = await KBYTBenhApi.list();
        this.mData.dataDefault.listKBYTBenh = resBenh.result;
        let resVaccine = await VaccineApi.list();
        this.mData.dataDefault.listVaccine = resVaccine.result;
    },
    fn_resetForm() {
        this.$refs["myForm"].clearValidate();
    },
    async fn_initData() {
        await this.getNationalityList();
        await this.getInitData();
        let data = sessionStorage.getItem("foreignRegister")
            ? JSON.parse(sessionStorage.getItem("foreignRegister"))
            : {};
        if (data) {
            this.mData.dataDefault.dataPassport = data;
        } else {
            sessionStorage.removeItem("foreignRegister");
            this.$router.push("/auth/travelpass-register/passport");
        }
    },
    async onDecode(decodedString) {
        // debugger
        this.mData.dataDefault.camera = 'off';
        // this.mData.dataForm.tiem_chung.qr = encodeURIComponent(decodedString);
        this.noMatchName = false;
        this.noMatchDOB = false;
        this.noMatchGender = false;
        this.noMatchPassportNo = false;
        this.mData.dataForm.tiem_chung.qr = decodedString.trim();
        try {
            const checkQrCodeRes = await ForeignerQrApi.checkQrCode(this.mData.dataForm.tiem_chung.qr); 
            if(checkQrCodeRes.result){
                console.log("checkQrCodeRes",checkQrCodeRes.result);
                if(
                    (checkQrCodeRes.result.ho_ten !="" && (checkQrCodeRes.result.ho_ten.toUpperCase() !== this.mData.dataDefault.dataPassport.dataPassport.ho_chieu.ho_ten.toUpperCase())) &&
                    (checkQrCodeRes.result.ngay_sinh != "" &&  (new Date(this.fomartDate(checkQrCodeRes.result.ngay_sinh)).getTime() != new Date(this.mData.dataDefault.dataPassport.dataPassport.ho_chieu.ngay_sinh).getTime()))
                ){
                    window.toastr.error("Information about name, date of birth on the vaccine certificate doesn’t match the information on your passport!");
                    this.mData.dataDefault.camera = 'auto';
                    this.mData.dataForm.tiem_chung.qr = null;
                    return
                }
                if(
                    checkQrCodeRes.result.ho_ten !="" && 
                    (checkQrCodeRes.result.ho_ten.toUpperCase() !== this.mData.dataDefault.dataPassport.dataPassport.ho_chieu.ho_ten.toUpperCase())
                ){
                    window.toastr.error("Information about name on the vaccine certificate doesn’t match the information on your passport!");
                    this.mData.dataDefault.camera = 'auto';
                    this.mData.dataForm.tiem_chung.qr = null;
                    this.noMatchName = true;
                }
                if(
                    checkQrCodeRes.result.ngay_sinh != "" && 
                    (new Date(this.fomartDate(checkQrCodeRes.result.ngay_sinh)).getTime() != new Date(this.mData.dataDefault.dataPassport.dataPassport.ho_chieu.ngay_sinh).getTime())
                ){
                    window.toastr.error("Information about date of birth on the vaccine certificate doesn’t match the information on your passport!");
                    this.mData.dataDefault.camera = 'auto';
                    this.mData.dataForm.tiem_chung.qr = null;
                    this.noMatchDOB = true;
                }
                if(
                    checkQrCodeRes.result.gioi_tinh != "" && 
                    (checkQrCodeRes.result.gioi_tinh !== this.mData.dataDefault.dataPassport.dataPassport.ho_chieu.gioi_tinh)
                ){
                    window.toastr.error("Information about gender on the vaccine certificate doesn’t match the information on your passport!");
                    this.mData.dataDefault.camera = 'auto';
                    this.mData.dataForm.tiem_chung.qr = null;
                    this.noMatchGender = true;
                }
                if(
                    checkQrCodeRes.result.so_ho_chieu != "" && 
                    (checkQrCodeRes.result.so_ho_chieu.toUpperCase() !== this.mData.dataDefault.dataPassport.dataPassport.ho_chieu.so_ho_chieu.toUpperCase())
                ){
                    window.toastr.error("Information passport number on the vaccine certificate doesn’t match the information on your passport!");
                    this.mData.dataDefault.camera = 'auto';
                    this.mData.dataForm.tiem_chung.qr = null;
                    this.noMatchPassportNo = true;
                }
                if(this.noMatchName || this.noMatchDOB || this.noMatchGender || this.noMatchPassportNo){
                    return
                }
                let checkExistedQrCodeRes = await ForeignerQrApi.checkExistedQrCode({
                    qr:this.mData.dataForm.tiem_chung.qr
                });
                console.log("checkExistedQrCodeRes",checkExistedQrCodeRes.result);
                if(checkExistedQrCodeRes.result.length == 0 || checkExistedQrCodeRes.result[0].count == 0){
                    if(checkQrCodeRes.result.thong_tin_tiem_chung.length > 0 ){
                        this.mData.dataDefault.showCamera = false;
                        this.mData.dataForm.tiem_chung.luot_tiem = [];
                        this.mData.dataForm.tiem_chung.vaccine = checkQrCodeRes.result.thong_tin_tiem_chung[0].vaccine.id;
                        this.mData.dataForm.tiem_chung.gia_tri_den = this.fomartDate(checkQrCodeRes.result.ngay_het_han);
                        this.mData.dataForm.tiem_chung.so_giay_chung_nhan = checkQrCodeRes.result.so_giay_chung_nhan;
                        if(checkQrCodeRes.result.thong_tin_tiem_chung[0].quoc_gia == undefined){
                            this.mData.dataForm.tiem_chung.quoc_gia_id = "";
                        }else{
                            this.mData.dataForm.tiem_chung.quoc_gia_id = checkQrCodeRes.result.thong_tin_tiem_chung[0].quoc_gia.id;
                        }
                        for(let i = 0; i < checkQrCodeRes.result.thong_tin_tiem_chung.length; i++){
                            this.mData.dataForm.tiem_chung.luot_tiem.push({
                                dia_diem_tiem: checkQrCodeRes.result.thong_tin_tiem_chung[i].dia_diem_tiem,
                                thoi_gian_tiem: this.fomartDate(checkQrCodeRes.result.thong_tin_tiem_chung[i].ngay_tiem)
                            })
                        }
                    }
                    console.log("this.mData.dataForm",this.mData.dataForm);
                }else{
                    window.toastr.error("The vaccination certificate has been used, please try again!");
                    this.mData.dataDefault.camera = 'auto';
                    this.mData.dataForm.tiem_chung.qr = undefined;
                    return
                }
            }
        } catch (error) {
            window.toastr.error("Invalid QR!");
            this.mData.dataDefault.camera = 'auto';
            this.mData.dataForm.tiem_chung.qr = undefined;
            return
        }
    },
    changeRadioValue(loai) {
        this.$refs["myForm"].clearValidate();
        this.$refs["myForm"].fields
            .find((f) => 
                f.prop == "tiem_chung.qr" ||
                f.prop == "tiem_chung.anh_id"
            )
            .resetField();
        this.fn_uploadRemoveAnh();
        if(loai == 1){
            this.mData.dataDefault.certificateByQR = false;
            this.mData.dataForm.tiem_chung.qr = null;
        }else if(loai == 2){
            this.mData.dataDefault.certificateByQR = true;
            this.mData.dataDefault.camera = 'auto';
            this.mData.dataForm.tiem_chung.qr = undefined;
            this.mData.dataDefault.showCamera = true;
            this.mData.dataForm.tiem_chung.anh_id = null;
        }
        this.mData.dataForm.loai = loai;
        this.mData.dataForm.tiem_chung.vaccine = null;
        this.mData.dataForm.tiem_chung.gia_tri_den = null;
        this.mData.dataForm.tiem_chung.so_giay_chung_nhan = null;
        this.mData.dataForm.tiem_chung.quoc_gia_id = null;
        this.mData.dataForm.tiem_chung.luot_tiem[0].dia_diem_tiem = null;
        this.mData.dataForm.tiem_chung.luot_tiem[0].thoi_gian_tiem = null;
        // this.mData.dataForm.tiem_chung.luot_tiem[1].dia_diem_tiem = null;
        // this.mData.dataForm.tiem_chung.luot_tiem[1].thoi_gian_tiem = null;
        this.fn_changeVaccine();
    },
    renderTimes(i) {
        if (i == 0) {
            return "1st";
        } else if (i == 1) {
            return "2nd";
        } else if (i == 2) {
            return "3rd";
        } else {
            return i + 1 + "th";
        }
    },
    fn_changeVaccine() {
        let vaccine = this.mData.dataDefault.listVaccine.find(
            (vac) => vac.id == this.mData.dataForm.tiem_chung.vaccine
        );
        if(vaccine == undefined){
            vaccine = {};
            vaccine.so_lan_tiem = 1;
        }
        if (vaccine && vaccine.so_lan_tiem) {
            if (
                this.mData.dataForm.tiem_chung.luot_tiem.length > vaccine.so_lan_tiem
            ) {
            this.mData.dataForm.tiem_chung.luot_tiem.splice(
                vaccine.so_lan_tiem,
                this.mData.dataForm.tiem_chung.luot_tiem.length -
                vaccine.so_lan_tiem
            );

            for (
                let i = vaccine.so_lan_tiem;
                i < this.mData.dataForm.tiem_chung.luot_tiem.length;
                i++
            ) {
                delete this.mData.validForm[ "tiem_chung.luot_tiem[" + i + "].thoi_gian_tiem" ];
                delete this.mData.validForm[ "tiem_chung.luot_tiem[" + i + "].dia_diem_tiem" ];
            }
            } else {
                while (
                    this.mData.dataForm.tiem_chung.luot_tiem.length <
                    vaccine.so_lan_tiem
                ) {
                    this.mData.dataForm.tiem_chung.luot_tiem.push({
                        thoi_gian_tiem: null,
                        dia_diem_tiem: "",
                    });
                    this.mData.validForm[
                    "tiem_chung.luot_tiem[" +
                        (this.mData.dataForm.tiem_chung.luot_tiem.length - 1) +
                        "].thoi_gian_tiem"
                    ] = [
                        {
                            required: true,
                            message: "Please enter a value",
                            trigger: "blur",
                        },
                        {
                            validator: this.validateNgayHetHan,
                            trigger: "blur",
                        },
                    ];
                    this.mData.validForm[
                    "tiem_chung.luot_tiem[" +
                        (this.mData.dataForm.tiem_chung.luot_tiem.length - 1) +
                        "].dia_diem_tiem"
                    ] = [
                        {
                            required: true,
                            message: "Please enter a value",
                            trigger: "blur",
                        },
                        ValidService.checkSpaceString
                    ];
                }
            }
        }
    },
    fomartDate(date){
        let datearray = date.split("/");
        return datearray[1] + '/' + datearray[0] + '/' + datearray[2];
    },

    validateNgayHetHan1(rule, value, callback) {
        if(!value){
            callback();
            return;
        }
        if (new Date(value).getTime() <= new Date().getTime()) {
            callback(new Error("Expiry date must be after today’s date"));
            return;
        }
        callback();
        return;
    },

    validateNgayHetHan(rule, value, callback) {
        if (new Date(value).getTime() >= new Date().getTime()) {
            callback(new Error("Injection time must be earlier than today"));
            return;
        }
        if (
            this.mData.dataForm.tiem_chung.gia_tri_den &&
            new Date(this.mData.dataForm.tiem_chung.gia_tri_den).getTime() <=
            new Date(value).getTime()
        ) {
            callback(new Error("Date of expiry must be later than Injection time"));
            return;
        }

        let index = Number(rule.field.match(/\d/)[0]);
        if (index == 0) {
            callback();
            return;
        }
        for (let i = 0; i < index; i++) {
            if (
                this.mData.dataForm.tiem_chung.luot_tiem[i].thoi_gian_tiem &&
                new Date(
                    this.mData.dataForm.tiem_chung.luot_tiem[i].thoi_gian_tiem
                ).getTime() >= new Date(value).getTime()
            ) {
            callback(
                new Error(
                    "Next injection time must be later than previous injection time"
                )
            );
            return;
            }
        }
        callback();
        return;
    },
    checkDifferenceArray(array1, array2) {
        let difItem = array1.filter((item) => {
            return !array2.includes(item);
        });
        if (array1.length == array2.length && difItem.length == 0) {
            return false;
        } else {
            return true;
        }
    },

    //upload ảnh
    fn_uploadCheckFileSize(file) {
        return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnh(file, fileList) {
        this.mData.dataDefault.anh = null;
        this.mData.dataForm.tiem_chung.anh_id = null;
        this.mData.fileUploadOption.Anh.fileList = [];
    },
    async fn_uploadChangeAnh(file, fileList) {
        ExtensionService.upload(file, "foreigner")
            .then((res) => {
            this.mData.dataForm.tiem_chung.anh_id = res.result;
            this.mData.dataDefault.anh =
                window.MyConfig.hostApi + "file/thumb?id=" + res.result;
            })
            .catch((error) => {
            console.log(error);
            window.toastr.error("An error occurred!");
            $.each(fileList, (i, el) => {
                if (el.uid == file.uid) {
                    fileList.splice(i, 1);
                }
            });
        });
    },
    fn_uploadExceedAnh(files, fileList) {
        window.toastr.info(
            `Only upload max ${this.mData.fileUploadOption.Anh.limit} file`
        );
    },
    fn_uploadPreviewAnh(file) {
        this.mData.fileUploadOption.Anh.dialogImageUrl = file.url;
        this.mData.fileUploadOption.Anh.dialogVisible = true;
    },
    fn_go() {
        this.$router.go(-1);
    },
    openCamera() {
      this.mData.dataDefault.camera = 'auto';
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    test(a){
        console.log("a",a);
    }
  },

  mounted() {
    this.mData.dataForm.loai = 1;
    this.fn_initData();
  },
  created() {},
};
</script>
<style lang="scss" scoped>
@font-face {
    font-family: UTM-Cafeta;
    src: url(/fonts/UTM_Cafeta.ttf);
}
@font-face {
    font-family: MYRIADPRO-REGULAR;
    src: url(/fonts/MYRIADPRO-REGULAR.OTF);
}
#registerSafePlaceUser-page {
    background-color: #e8eef2;
    background-attachment: fixed;
    background-position: top center;
}
.box-image{
    max-width: 500px;
    text-align: center;
}
.card{
    box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px;
}
.card-header{
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 55px;
    background-color: #0c66ad;
    border-color: #0c66ad;
    display: flex;
    align-items: center;
    justify-content: center;
}
.card-header p{
    margin-bottom: 0 !important;
    color: #ffffff;
    font-size: 20px;
}
.card-body{
    padding: 20px 20px 0 20px;
}
.card-footer{
    background-color: #0c66ad;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    height: 10px;
    padding: 0;
}
.btn-group{
    padding: 0 50px 0 50px;
    display: flex;
    justify-content: space-between;
}
.btn-group .btn-back{
    background-color: #ade0eb;
    border-color: #ade0eb;
    color: #0c66ad;
    font-weight: 700;
}
.btn-group .btn-back:hover{
    border-color: #ade0eb;
}
.btn-group .btn-next{
    background-color: #0c66ad;
    border-color: #0c66ad;
}
.btn-group .btn-next:hover{
    border-color: #0c66ad;
}
.hide {
    ::v-deep.el-upload.el-upload--text {
        display: none;
    }
}
::v-deep .el-collapse-item__header{
    color: #0c66ad;
    font-family: MYRIADPRO-REGULAR;
    font-weight: 600;
}
::v-deep .el-form-item__label{
    color: #0c66ad;
    font-family: MYRIADPRO-REGULAR;
    font-weight: 600;
}
::v-deep .el-button.is-disabled:hover{
    cursor: not-allowed;
}
::v-deep .el-upload {
    display: block;
    margin-bottom: 15px;
}
::v-deep .text-center input{
  text-align: center;
}

.email-notice {
    line-height: 18px;
    font-size: 11.5px;
}

@media screen and (max-width: 767px) {
    h3 {
        font-size: 16px;
    }
    h2 {
        font-size: 17px;
    }
    h4 {
        font-size: 16px;
    }
    h5 {
        font-size: 14px;
    }
    .text {
        font-size: 12px;
    }
}
</style>
<style scope>
.el-message-box {
    width: 540px;
}
@media (max-width: 992px) {
    .el-message-box {
        width: 500px;
    }
}
@media (max-width: 584px) {
    .el-message-box {
        width: 400px;
    }
}
@media (max-width: 454px) {
    .el-message-box {
        width: 300px;
    }
}
@media (max-width: 310px) {
    .el-message-box {
        width: 240px;
    }
}
</style>